import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 5H1v18h18v-2H3V5zm20-4H5v18h18V1zm-2 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z"
}), 'Filter7Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Filter7Sharp.js
// module id = 3608
// module chunks = 2